export default __webpack_public_path__ + "static/media/history.aca9565f.png";